import { render, staticRenderFns } from "./ConfigScheduleNotifications.vue?vue&type=template&id=5e00c338&scoped=true&"
import script from "./ConfigScheduleNotifications.vue?vue&type=script&lang=js&"
export * from "./ConfigScheduleNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScheduleNotifications.vue?vue&type=style&index=0&id=5e00c338&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e00c338",
  null
  
)

export default component.exports